export const globalMixin = {
  data() {
    return {}
  },
  //   created() {
  //     this.logMessage()
  //   },
  methods: {
    priceConvert(xVal) {
      const num = 0
      let digitVal = 3
      if (this.digitAfterComa != null && this.digitAfterComa > 0) {
        digitVal = this.digitAfterComa
      }
      if (xVal != undefined) {
        if (xVal != null) {
          let round = parseFloat(xVal)
          if (round.toString().includes('.')) {
            round = parseFloat(round).toFixed(digitVal)
          }
          const val = round + ''
          let result = ''

          if (val.includes('.')) {
            const splitVal = val.split('.')
            const main = splitVal[0]
            const decimal = splitVal[1]
            result =
              main.toString().replace(/\B(?<!\\d*)(?=(\d{3})+(?!\d))/g, ',') +
              `.${decimal}`
          } else {
            result = val
              .toString()
              .replace(/\B(?<!\\d*)(?=(\d{3})+(?!\d))/g, ',')
          }
          return result
        }
      }
      return num
    },
    generatePDF(url, axios) {
      const win = window.open('', '_blank')
      if (!win) {
        alert('Popup diblokir')
        return
      }
      // Tampilkan loading di tab baru
      win.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
        <style>
        body{
            margin:0;
            height:100vh;
            display:flex;
            flex-direction:column;
            justify-content:center;
            align-items:center;
            font-family:Arial,sans-serif;
        }
        .spinner{
            width:48px;
            height:48px;
            border:5px solid #ddd;
            border-top:5px solid #1976d2;
            border-radius:50%;
            animation:spin 1s linear infinite;
            margin-bottom:20px;
        }
        @keyframes spin{
            to { transform: rotate(360deg); }
        }
        </style>
        </head>
        <body>
            <div class="spinner"></div>
            <h2>Please wait...</h2>
            <p>Preparing your document.</p>
        </body>
        </html>
        `)
      win.document.close()
      setTimeout(() => {
        axios({
          url: url,
          method: 'GET',
          responseType: 'blob'
          // responseType: 'arraybuffer'
        })
          .then((res) => {
            this.selectedPdf = res.data
            const url = URL.createObjectURL(res.data)
            // window.open(url, '_blank')
            win.location.replace(url)

            // setTimeout(() => URL.revokeObjectURL(url), 5000)
          })
          .catch((error) => {
            console.log(error)
            win.document.body.innerHTML = `
                <h2>Failed to load document.</h2>
                <p>Please try again.</p>
            `
          })
      }, 1000)
    },
    convertDateLocal(raw, stateCode) {
      if (raw !== null) {
        const date = new Date(raw)
        const local = date.toLocaleString(stateCode)
        return local
      } else {
        return '-'
      }
    },
    showMsgDialog3(pModalType, pStatusMsg, pBtnCancel, yesBtn, noBtn, pText) {
      let additional = ''
      if (pText !== undefined) {
        additional = '<span style="font-size:12px;">' + pText + '</span>'
      }
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html:
              '<strong style="font-size:18px;">' +
              pStatusMsg +
              '</strong>' +
              '<br/>' +
              additional,
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            confirmButtonText: yesBtn,
            cancelButtonText: noBtn !== '' ? noBtn : 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },

    getPayloadSize(data) {
      const jsonString = JSON.stringify(data)
      const sizeInBytes = new Blob([jsonString]).size
      return sizeInBytes
    },

    formatBytes(bytes) {
      if (bytes === 0) return '0 Bytes'
      const k = 1024
      const sizes = ['Bytes', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return `${(bytes / Math.pow(k, i)).toFixed(2)} ${sizes[i]}`
    }
  }
}
